module.exports = __webpack_public_path__ + "media/images/amenities_icons/mac-a36427461799dcc0325c7e7e62b6d542.svg";